<template>
  <div class="wrap">
    <NavBar :title="$t('转账')" />
    <div class="wrap_cont">
      <div class="transfer_card">
        <div class="transfer_section">
          <h2>{{ $t('收款人资讯') }}</h2>
          <div class="transfer_input">
            <van-icon name="manager-o" size="18" color="#f3c96b" />
            <van-field v-model="form.to_userid" :placeholder="$t('请输入对方ID')" />
          </div>
        </div>
        <div class="transfer_divider"></div>
        <div class="transfer_section">
          <h2>{{ $t('转账金额') }}</h2>
          <div class="transfer_input">
            <van-icon name="paid" size="18" color="#f3c96b" />
            <van-field v-model="form.money" :placeholder="$t('请输入转账金额')" />
          </div>
        </div>
        <div class="transfer_balance">
          <span>{{ $t('availableBalance') }}：{{ $money(userInfo.money || '0.00') }}</span>
          <div class="all" @click="all">{{ $t('all') }}</div>
        </div>
        <div class="transfer_divider"></div>
        <div class="transfer_section">
          <h2>{{ $t('交易密码') }}</h2>
          <div class="transfer_input">
            <van-icon name="lock" size="18" color="#f3c96b" />
            <van-field v-model="form.paypass" :placeholder="$t('请输入交易密码')" />
          </div>
        </div>
        <div class="transfer_divider"></div>
        <div class="transfer_section">
          <h2>{{ $t('备注说明') }}<span>({{ $t('可选') }})</span></h2>
          <div class="transfer_textarea">
            <van-field v-model="remark" rows="2" autosize type="textarea" maxlength="20" :placeholder="$t('给对方留言')"
              show-word-limit />
          </div>
        </div>
      </div>
    </div>
    <div class="btn">
      <div class="btn_text app_card" :style="hasAllValuesLoose() ? {} : { opacity: .5 }" @click="submit">{{ $t('确认转账')
      }}
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/JNav";
import { Icon, Field, Toast } from "vant"
import { mapGetters } from "vuex";
import { USERS_TRANSFER } from "@/api"
export default {
  components: {
    NavBar,
    [Icon.name]: Icon,
    [Field.name]: Field,
    Toast
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      form: {
        to_userid: '',
        money: '',
        paypass: ''
      },
      remark: ''
    }
  },
  created() {
    this.$store.dispatch("getuserInfo");
  },
  methods: {
    all() {
      this.form.money = this.userInfo.money
    },
    order() {
      console.log('订单');

    },
    hasAllValuesLoose() {
      let obj = this.form;
      if (!obj || typeof obj !== 'object') return false;
      const keys = Object.keys(obj);
      if (keys.length === 0) return false;
      return keys.every(key => {
        const val = obj[key];
        if (typeof val === 'string') {
          return val.trim().length > 0;
        }
        if (Array.isArray(val)) {
          return val.length > 0;
        }
        if (typeof val === 'number') {
          return !isNaN(val);
        }
        return !!val;
      });
    },
    async submit() {
      if (!this.hasAllValuesLoose()) return;
      try {
        const res = await USERS_TRANSFER({
          ...this.form,
          remark: this.remark
        })
        Toast.clear();
        Toast(res.msg)
        setTimeout(()=>{
          this.$router.go(-1);
        },100)
        console.log(this.form);
      } catch (error) {
        Toast.clear();
        Toast(error.msg);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: calc(100vh - 60px - 18px);
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);
  padding: 0 0 78px;

  .wrap_cont {
    padding: 14px 10px 0;

    .transfer_card {
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding: 16px 16px 17px;
      background: #fff;
      border: 1px solid rgba(116, 137, 171, .18);
      border-radius: 24px;
      box-shadow: 0 22px 54px #ffffff52;
    }

    .transfer_section {
      display: grid;
      gap: 14px;

      h2 {
        font-size: 18px;
        color: #0f172a;
        padding: 0;
        margin: 0;
      }

      .transfer_input,
      .transfer_textarea {
        display: flex;
        align-items: center;
        min-height: 50px;
        border: 1px solid rgba(116, 137, 171, .18);
        border-radius: 18px;
        padding: 0 16px;
        background: #fff;
        gap: 10px;

        :deep(.van-field) {
          padding: 0;
        }
      }

      .transfer_textarea {
        :deep(.van-field) {
          padding: 16px 0;
        }
      }
    }

    .transfer_balance {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #7a8597;
      font-size: 15px;

      .all {
        background: linear-gradient(90deg, #8ff5d1, #31e2a5);
        color: #0f172a;
        border-radius: 8px;
        height: 30px;
        padding: 0 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .transfer_divider {
      height: 1px;
      background: #7489ab24;
    }
  }

  .btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;


    .btn_text {
      height: 40px;
      border-radius: 10000px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      background: linear-gradient(90deg, #8ff5d1, #31e2a5);
      box-shadow: 0 9px 20px #31e2a547;
      font-weight: 600;
    }
  }
}
</style>